import React from 'react';
import { useFetchFlatCommentAttachment } from '../../../../queries/roomCommentAttachment';
import { useInvalidateFlatComments } from '../../../../queries/useFlatComments';
import useAddFlatComment from '../../../../mutations/addFlatComment';
import useEditFlatComment from '../../../../mutations/editFlatComment';
import useDeleteFlatComment from '../../../../mutations/deleteFlatComment';
import useAddFlatCommentAttachment from '../../../../mutations/addFlatCommentAttachment';
import useDeleteFlatCommentAttachment from '../../../../mutations/deleteFlatCommentAttachment';
import CommentsModalTemplate from '../../../commentsModalTemplate';
import getName from '../../../../helpers/getName';

const Wrapper = ({ children, addressId }) => {
  const getCommentAttachment = useFetchFlatCommentAttachment(addressId);

  const invalidateComments = useInvalidateFlatComments();

  const onSuccess = () => {
    invalidateComments(addressId);
  };

  const { mutateAsync: addComment } = useAddFlatComment({ onSuccess });
  const { mutateAsync: editComment } = useEditFlatComment({ onSuccess });
  const { mutateAsync: deleteComment } = useDeleteFlatComment({ onSuccess });
  const { mutateAsync: addAttachment } = useAddFlatCommentAttachment();
  const { mutateAsync: deleteAttachment } = useDeleteFlatCommentAttachment();

  const handleAddComment = async ({ comment, attachments }) => {
    await addComment({ comment, attachments, addressId });
  };

  const handleEditComment = async ({ comment, target, attachments }) => {
    const { attachments: prevAttachments = [], id } = target;

    const { mutating, existing } = attachments.reduce(
      (result, attachment) => {
        if (attachment instanceof File) {
          result.mutating.push(
            addAttachment({ file: attachment, addressId, commentId: id })
          );
        } else {
          result.existing.add(attachment);
        }

        return result;
      },
      { mutating: [], existing: new Set() }
    );

    prevAttachments.forEach((attachment) => {
      if (!existing.has(attachment)) {
        mutating.push(
          deleteAttachment({
            addressId,
            commentId: id,
            attachId: attachment.id,
          })
        );
      }
    });

    if (mutating.length) {
      await Promise.allSettled(mutating);
    }

    await editComment({ comment, addressId, commentId: id });
  };

  const handleDeleteComment = async (commentId) => {
    await deleteComment({ addressId, commentId });
  };

  return (
    <CommentsModalTemplate
      getCommentAttachment={getCommentAttachment}
      onAddComment={handleAddComment}
      onEditComment={handleEditComment}
      onDeleteComment={handleDeleteComment}
      getWorkerName={getName}
    >
      {children}
    </CommentsModalTemplate>
  );
};

export default Wrapper;
